export default __webpack_public_path__ + "static/media/neptune2.6707b164.png";